import { isChildNode } from 'utils/is-child-node';
import { CK_VARIABLES_POPUP } from 'vendor/ckeditor/plugins/variables/types';
import { CK_MENTION_POPUP } from 'vendor/ckeditor/react-components/mention';
import { CKE5_NODE_CLASS } from './ck-editor5';
import { EMOJI_NODE_CLASS } from './emoji-picker';

export { RichTextEditor } from './rich-text-editor';
export type { RichTextEditorProps } from './rich-text-editor';

// Mention pop must be treated as child to capture mention selection with mouse
export const isEditorNode = isChildNode([
  EMOJI_NODE_CLASS,
  CKE5_NODE_CLASS,
  CK_MENTION_POPUP,
  CK_VARIABLES_POPUP,
]);
